import { useNavigate } from "react-router-dom";
import { useUpdateProduct } from "../../features/product";
import NumberFormat from "../../utils/NumberFormat";
import ModalConfirmationDelete from "../../components/ModalConfirmationDelete";
import { useState } from "react";
import { BsToggleOn, BsToggleOff, BsPencilFill } from "react-icons/bs";
import { useGetAllProduct } from "../../features/product/hooks/useGetAllProduct";

const ProductPage = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [id, setId] = useState("");
  const [status, setStatus] = useState<"INACTIVE" | "ACTIVE">("INACTIVE");
  const { product } = useGetAllProduct();
  const { Update } = useUpdateProduct();

  const navigate = useNavigate();

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleConfirmToggleStatus = () => {
    Update({ id, status });
    setIsModalOpen(false);
  };

  const handleStatusClick = (
    productId: string,
    currentStatus: "ACTIVE" | "INACTIVE"
  ) => {
    setId(productId);
    setStatus(currentStatus === "ACTIVE" ? "INACTIVE" : "ACTIVE");
    setIsModalOpen(true);
  };

  return (
    <>
      <div className="p-6">
        <div className="overflow-x-auto">
          <div className="flex justify-between mb-5">
            <h1 className="mt-2 mb-5 font-semibold text-xl text-gray-900">
              Product List
            </h1>
            <button
              type="button"
              onClick={() => navigate("/product/create")}
              className="mt-6 text-xs px-3 py-2 bg-green-500 text-white font-medium rounded-md focus:outline-none focus:ring-2"
            >
              Create
            </button>
          </div>
          <table className="min-w-full bg-white rounded-lg shadow-md">
            <thead className="bg-blue-800 text-white">
              <tr>
                <th className="px-6 py-3 text-left text-sm font-medium">
                  Name
                </th>
                <th className="px-6 py-3 text-left text-sm font-medium">
                  Code
                </th>
                <th className="px-6 py-3 text-left text-sm font-medium">
                  Category
                </th>
                <th className="px-6 py-3 text-left text-sm font-medium">
                  Operator
                </th>
                <th className="px-6 py-3 text-left text-sm font-medium">
                  Payment Type
                </th>
                <th className="px-6 py-3 text-left text-sm font-medium">
                  Price
                </th>
                <th className="px-6 py-3 text-left text-sm font-medium">
                  Description
                </th>
                <th className="px-6 py-3 text-left text-sm font-medium">
                  Status
                </th>
                <th className="px-6 py-3 text-left text-sm font-medium">
                  Action
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
              {product?.map((item, index) => (
                <tr key={index} className="hover:bg-gray-50">
                  <td className="px-6 py-4 text-sm text-gray-700">
                    {item.name}
                  </td>
                  <td className="px-6 py-4 text-sm text-gray-700">
                    {item.code}
                  </td>
                  <td className="px-6 py-4 text-sm text-gray-700">
                    {item.productCategory?.name ?? "-"}
                  </td>
                  <td className="px-6 py-4 text-sm text-gray-700">
                    {item.category}
                  </td>
                  <td className="px-6 py-4 text-sm text-gray-700">
                    {item.paymentType}
                  </td>
                  <td className="px-6 py-4 text-sm text-gray-700">
                    <NumberFormat value={item.price} prefix="Rp. " />
                  </td>
                  <td className="px-6 py-4 text-sm text-gray-700">
                    {item.description}
                  </td>
                  <td className="px-6 py-4 text-sm text-gray-700 flex items-center gap-3">
                    <td className="px-6 py-4 text-sm flex gap-5 items-center text-gray-700">
                      <button
                        title={
                          item.status === "ACTIVE"
                            ? "Nonaktifkan Produk"
                            : "Aktifkan Produk"
                        }
                        onClick={() => handleStatusClick(item.id, item.status)}
                        className="text-2xl transition duration-150"
                      >
                        {item.status === "ACTIVE" ? (
                          <BsToggleOn className="text-green-500 cursor-pointer hover:text-green-700" />
                        ) : (
                          <BsToggleOff className="text-gray-400 cursor-pointer hover:text-red-600" />
                        )}
                      </button>
                    </td>
                  </td>
                  <td className="px-6 py-4 text-sm text-gray-700">
                    <BsPencilFill
                      className="text-gray-400 cursor-pointer hover:text-red-600"
                      onClick={() => navigate(`/product/update/${item.id}`)}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <ModalConfirmationDelete
        isOpen={isModalOpen}
        title={`Apakah Anda yakin ingin mengubah status produk menjadi ${status}?`}
        onClose={handleCloseModal}
        onConfirm={handleConfirmToggleStatus}
      />
    </>
  );
};

export default ProductPage;
